export * from './alert.reducer';
export * from './authentication.reducer';
export * from './contractReviewer.reducer';
export * from './category.reducer';
export * from './analysis.reducer';


// WEBPACK FOOTER //
// ./src/reducers/index.js